import {
  Button,
  CircularProgress,
  createStyles,
  Grid,
  makeStyles,
  Theme,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import clsx from "clsx";
import * as React from "react";
import { ON_SEE_AS_MODE } from "../../core/constants/tooltipHelpersText";
import IUserResponse from "../../core/contracts/IUserResponse";
import useConstructor from "../../core/hooks/useConstructor";
import { SessionCache } from "../../helpers/cache";
import ButtonSwitch from "../ButtonSwitch";
import MaterialDateTimePickerComponent from "../MaterialDateTimePickerComponent";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      "padding": theme.spacing(1, 2),
      "alignItems": "center",
      "background": theme.customPaper.background.cardBackgroundLight,

      "& .flex-grow": {
        flexGrow: 1,
      },
    },

    gridWrapper: {
      "display": "flex",
      "alignItems": "center",
      "columnGap": theme.spacing(1),
      "flexWrap": "wrap",

      "& .label": {
        color: theme.palette.text.secondary,
        fontWeight: "bold",
      },
    },

    button: {
      "fontWeight": "bold",

      "&:hover": {
        color: theme.palette.primary.main,
      },
    },
  })
);

type InstallationLevelReportHeaderProps = {
  date: MaterialUiPickersDate;
  loadInformation: boolean;
  handleChangeDate: (date: MaterialUiPickersDate, value?: string | null | undefined) => void;
  handleChangeLoadInformation: (newValue: boolean) => void;
  handleClickRegister: (event: React.ChangeEvent<unknown>) => void;
  disableSendButton?: boolean;
  buttonLoading?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  buttonTooltip?: any;
};

function InstallationLevelReportHeader({
  date,
  loadInformation,
  handleChangeDate,
  handleChangeLoadInformation,
  handleClickRegister,
  buttonTooltip,
  disableSendButton = false,
  buttonLoading = false,
}: InstallationLevelReportHeaderProps) {
  const classes = useStyles();
  const [onSeeAsMode, setOnSeeAsMode] = React.useState<boolean>();

  useConstructor(() => {
    const sessionCache = new SessionCache();
    const user: IUserResponse | null = sessionCache.get("user");
    if (user?.onSeeAsMode) {
      setOnSeeAsMode(true);
    }
  });

  return (
    <Grid className={classes.root} container spacing={2}>
      <Grid className={classes.gridWrapper} item>
        <Typography className="label">Data e Hora de Leitura:</Typography>
        <MaterialDateTimePickerComponent
          clearable
          value={date}
          disableFuture
          maxDate={new Date()}
          onChange={handleChangeDate}
          maxDateMessage="A data não pode ser futura"
          error={date === null}
        />
      </Grid>

      <Grid className={clsx("flex-grow", classes.gridWrapper)} item>
        <Typography className="label">Ocorreu carregamento desde a última medição?</Typography>
        <ButtonSwitch
          onLabel="Sim"
          offLabel="Não"
          value={loadInformation}
          onClick={handleChangeLoadInformation}
        />
      </Grid>

      <Grid item>
        {!buttonLoading && (
          <Tooltip title={onSeeAsMode ? ON_SEE_AS_MODE : buttonTooltip}>
            <span>
              <Button
                className={classes.button}
                disabled={onSeeAsMode ? true : disableSendButton}
                onClick={handleClickRegister}
                variant="outlined"
              >
                Gravar Dados
              </Button>
            </span>
          </Tooltip>
        )}

        {buttonLoading && <CircularProgress />}
      </Grid>
    </Grid>
  );
}

export default InstallationLevelReportHeader;
